// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  cursor: pointer;
  color: var(--link-color);
}

.action-row .action-row-div {
  height: 100%;
  display: flex;
  flex-flow: column;
}
.action-row .action-row-div ul {
  flex-grow: 1;
}

.action-buttons {
  display: flex;
  align-items: center;
  width: auto;
  margin: auto;
}
.action-buttons .button-spacing {
  width: 100px;
}
.action-buttons .button-spacing:not(:first-child) {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/player-dashboard/promotion-action-buttons/promotion-action-buttons.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,wBAAA;AACF;;AAGE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAFF;AAIE;EACE,YAAA;AAFJ;AAII;EACE,iBAAA;AAFN","sourcesContent":["a {\r\n  cursor: pointer;\r\n  color: var(--link-color);\r\n}\r\n\r\n.action-row {\r\n  .action-row-div {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-flow: column;\r\n\r\n    ul {\r\n      flex-grow: 1;\r\n    }\r\n  }\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n  width: auto;\r\n  margin: auto;\r\n\r\n  .button-spacing {\r\n    width: 100px;\r\n\r\n    &:not(:first-child) {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
